import { FETCH_REVENUE_CENTERS } from '../RevenueCenters/actionTypes'
import { FETCH_REVENUE_CENTER_ORDERS } from '../Orders/actionTypes'

import get from 'lodash/get'

const initialState = {
  message: null,
  logo: null,
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_REVENUE_CENTERS: {
      return {
        message: get(payload, 'orderingBoardMessage', initialState.message),
        logo: get(payload, 'orderingBoardLogo', initialState.logo),
      }
    }

    case FETCH_REVENUE_CENTER_ORDERS: {
      return {
        message: get(payload, 'data.orderingBoardMessage', initialState.message),
        logo: get(payload, 'data.orderingBoardLogo', initialState.logo),
      }
    }

    default:
      return state
  }
}
